export default __webpack_public_path__ + "static/media/2096-00.f48d38a8.jpg";